/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  AppointmentPortalResponse,
  AppointmentResponse,
  LightAppointment,
  PortalAppointmentRequest,
  UpdateAppointmentLocation,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    AppointmentPortalResponseFromJSON,
    AppointmentPortalResponseToJSON,
    AppointmentResponseFromJSON,
    AppointmentResponseToJSON,
    LightAppointmentFromJSON,
    LightAppointmentToJSON,
    PortalAppointmentRequestFromJSON,
    PortalAppointmentRequestToJSON,
    UpdateAppointmentLocationFromJSON,
    UpdateAppointmentLocationToJSON,
} from '../models/index';

export interface CancelAppointmentRequest {
    appointmentUuid: string;
}

export interface CreateAppointmentFromPortalRequest {
    portalAppointmentRequest: PortalAppointmentRequest;
}

export interface FinishAppointmentRequest {
    appointmentId: string;
}

export interface GetAppointmentRequest {
    appointmentUuid: string;
}

export interface IsAppointmentAvailableRequest {
    doctorUuid?: string;
    appointmentDateTime?: string;
    appointmentDuration?: number;
}

export interface SearchNextAppointmentAvailabilityRequest {
    doctorUuid: string;
    instituteUuid: string;
    appointmentTypeUuid: string;
}

export interface SetAppointmentLocationRequest {
    appointmentId: string;
    updateAppointmentLocation: UpdateAppointmentLocation;
}

export interface UpdateStatusAppointmentRequest {
    appointmentUuid: string;
    portalAppointmentRequest?: PortalAppointmentRequest;
}

/**
 * 
 */
export class AppointmentApi extends runtime.BaseAPI {

    /**
     * Cancel an appointment from portal
     */
    async cancelAppointmentRaw(requestParameters: CancelAppointmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['appointmentUuid'] == null) {
            throw new runtime.RequiredError(
                'appointmentUuid',
                'Required parameter "appointmentUuid" was null or undefined when calling cancelAppointment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/appointment/{appointment_uuid}`.replace(`{${"appointment_uuid"}}`, encodeURIComponent(String(requestParameters['appointmentUuid']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Cancel an appointment from portal
     */
    async cancelAppointment(requestParameters: CancelAppointmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.cancelAppointmentRaw(requestParameters, initOverrides);
    }

    /**
     * Create an appointment from the portal
     */
    async createAppointmentFromPortalRaw(requestParameters: CreateAppointmentFromPortalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AppointmentPortalResponse>> {
        if (requestParameters['portalAppointmentRequest'] == null) {
            throw new runtime.RequiredError(
                'portalAppointmentRequest',
                'Required parameter "portalAppointmentRequest" was null or undefined when calling createAppointmentFromPortal().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/appointments`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PortalAppointmentRequestToJSON(requestParameters['portalAppointmentRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AppointmentPortalResponseFromJSON(jsonValue));
    }

    /**
     * Create an appointment from the portal
     */
    async createAppointmentFromPortal(requestParameters: CreateAppointmentFromPortalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AppointmentPortalResponse> {
        const response = await this.createAppointmentFromPortalRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ends an appointment
     */
    async finishAppointmentRaw(requestParameters: FinishAppointmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AppointmentResponse>> {
        if (requestParameters['appointmentId'] == null) {
            throw new runtime.RequiredError(
                'appointmentId',
                'Required parameter "appointmentId" was null or undefined when calling finishAppointment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/appointments/{appointment_id}/finish`.replace(`{${"appointment_id"}}`, encodeURIComponent(String(requestParameters['appointmentId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AppointmentResponseFromJSON(jsonValue));
    }

    /**
     * ends an appointment
     */
    async finishAppointment(requestParameters: FinishAppointmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AppointmentResponse> {
        const response = await this.finishAppointmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve an specific appointment 
     * Get the information of an appointment
     */
    async getAppointmentRaw(requestParameters: GetAppointmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LightAppointment>> {
        if (requestParameters['appointmentUuid'] == null) {
            throw new runtime.RequiredError(
                'appointmentUuid',
                'Required parameter "appointmentUuid" was null or undefined when calling getAppointment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/appointment/{appointment_uuid}`.replace(`{${"appointment_uuid"}}`, encodeURIComponent(String(requestParameters['appointmentUuid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LightAppointmentFromJSON(jsonValue));
    }

    /**
     * Retrieve an specific appointment 
     * Get the information of an appointment
     */
    async getAppointment(requestParameters: GetAppointmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LightAppointment> {
        const response = await this.getAppointmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check if an appointment is available
     */
    async isAppointmentAvailableRaw(requestParameters: IsAppointmentAvailableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        if (requestParameters['doctorUuid'] != null) {
            queryParameters['doctorUuid'] = requestParameters['doctorUuid'];
        }

        if (requestParameters['appointmentDateTime'] != null) {
            queryParameters['appointmentDateTime'] = requestParameters['appointmentDateTime'];
        }

        if (requestParameters['appointmentDuration'] != null) {
            queryParameters['appointmentDuration'] = requestParameters['appointmentDuration'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/appointments/available`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Check if an appointment is available
     */
    async isAppointmentAvailable(requestParameters: IsAppointmentAvailableRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.isAppointmentAvailableRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search for the next possible appointment
     */
    async searchNextAppointmentAvailabilityRaw(requestParameters: SearchNextAppointmentAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['doctorUuid'] == null) {
            throw new runtime.RequiredError(
                'doctorUuid',
                'Required parameter "doctorUuid" was null or undefined when calling searchNextAppointmentAvailability().'
            );
        }

        if (requestParameters['instituteUuid'] == null) {
            throw new runtime.RequiredError(
                'instituteUuid',
                'Required parameter "instituteUuid" was null or undefined when calling searchNextAppointmentAvailability().'
            );
        }

        if (requestParameters['appointmentTypeUuid'] == null) {
            throw new runtime.RequiredError(
                'appointmentTypeUuid',
                'Required parameter "appointmentTypeUuid" was null or undefined when calling searchNextAppointmentAvailability().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['doctorUuid'] != null) {
            queryParameters['doctorUuid'] = requestParameters['doctorUuid'];
        }

        if (requestParameters['instituteUuid'] != null) {
            queryParameters['instituteUuid'] = requestParameters['instituteUuid'];
        }

        if (requestParameters['appointmentTypeUuid'] != null) {
            queryParameters['appointmentTypeUuid'] = requestParameters['appointmentTypeUuid'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/appointments/next-availability`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Search for the next possible appointment
     */
    async searchNextAppointmentAvailability(requestParameters: SearchNextAppointmentAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.searchNextAppointmentAvailabilityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * sets the location of an appointment
     */
    async setAppointmentLocationRaw(requestParameters: SetAppointmentLocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateAppointmentLocation>> {
        if (requestParameters['appointmentId'] == null) {
            throw new runtime.RequiredError(
                'appointmentId',
                'Required parameter "appointmentId" was null or undefined when calling setAppointmentLocation().'
            );
        }

        if (requestParameters['updateAppointmentLocation'] == null) {
            throw new runtime.RequiredError(
                'updateAppointmentLocation',
                'Required parameter "updateAppointmentLocation" was null or undefined when calling setAppointmentLocation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/appointments/{appointment_id}/location`.replace(`{${"appointment_id"}}`, encodeURIComponent(String(requestParameters['appointmentId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateAppointmentLocationToJSON(requestParameters['updateAppointmentLocation']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateAppointmentLocationFromJSON(jsonValue));
    }

    /**
     * sets the location of an appointment
     */
    async setAppointmentLocation(requestParameters: SetAppointmentLocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateAppointmentLocation> {
        const response = await this.setAppointmentLocationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update the appointment
     */
    async updateStatusAppointmentRaw(requestParameters: UpdateStatusAppointmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LightAppointment>> {
        if (requestParameters['appointmentUuid'] == null) {
            throw new runtime.RequiredError(
                'appointmentUuid',
                'Required parameter "appointmentUuid" was null or undefined when calling updateStatusAppointment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/appointment/{appointment_uuid}`.replace(`{${"appointment_uuid"}}`, encodeURIComponent(String(requestParameters['appointmentUuid']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PortalAppointmentRequestToJSON(requestParameters['portalAppointmentRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LightAppointmentFromJSON(jsonValue));
    }

    /**
     * Update the appointment
     */
    async updateStatusAppointment(requestParameters: UpdateStatusAppointmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LightAppointment> {
        const response = await this.updateStatusAppointmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
